export const RefundStatus = {
    Processed: 'PROCESSED',
    'Not processed': 'NOT-PROCESSED',
    All: 'ALL'
};
